const permissionsModuleName = {
  Charities: "Charitable Events",
  Articles: "Library",
};

export { permissionsModuleName };
